module.exports = __webpack_public_path__ + "img/communication.0544b32a.svg";